import { render, staticRenderFns } from "./SettingsDVRConfigView.vue?vue&type=template&id=e807634e&scoped=true&"
import script from "./SettingsDVRConfigView.vue?vue&type=script&lang=js&"
export * from "./SettingsDVRConfigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e807634e",
  null
  
)

export default component.exports